import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('authtoken');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        localStorage.removeItem('authtoken');
        // Optionally, trigger a logout action or redirect the user
    }

    return result;
};

export const WorkoutApi = createApi({
    reducerPath: 'WorkoutApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getAllCategory: builder.query({
            query: () => `/workout/category-getall/`,
        }),
        postCategory: builder.mutation({
            query: (data) => ({
                url: `/workout/category-create/`,
                method: "POST",
                body: data,
            }),
        }),
        postSubCategory: builder.mutation({
            query: (data) => ({
                url: `/workout/subcategory-create/`,
                method: "POST",
                body: data,
            }),
        }),
        getSubCategory: builder.query({
            query: (category_id) => ({
                url: `/workout/subcategories/${category_id}/`,
                method: "GET",

            }),
        }),
        postWorkout: builder.mutation({
            query: (data) => ({
                url: `/workout/workouts/`,
                method: "POST",
                body: data,
            }),
        }),
        getWorkout: builder.query({
            query: (param) => ({
                url: `/workout/workouts/`,
                method: "GET",
                params: param
            }),
        }),
        updateWorkout: builder.mutation({
            query: ({ id, data }) => ({
                url: `/workout/workouts/${id}/`,
                method: 'PUT',
                body: data,
                formData: true,
            })
        }),
        deleteWorkout: builder.mutation({
            query: (id) => ({
                url: `/workout/workouts/${id}/`,
                method: 'DELETE'
            })
        }),

    }),
});

export const { useGetAllCategoryQuery, usePostCategoryMutation, usePostSubCategoryMutation, useGetSubCategoryQuery, usePostWorkoutMutation, useGetWorkoutQuery, useUpdateWorkoutMutation, useDeleteWorkoutMutation } = WorkoutApi;
